import { Button, Card, Typography, CardActions, Box, Stack } from "@mui/material"
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useNavigate } from "react-router-dom";

const CardCreateFilter = (props) => {
	const navigate 		= useNavigate()

	return (
		<Card sx={{ p: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
			<Box
				sx={{
					width: 140,
					height: 210,
					borderRadius: 2,
					border: '2px dashed',
					borderColor: 'primary.light',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					color: 'primary.main',
					fontSize: 48,
					flexShrink: 0
				}}
			>
				+
			</Box>
			<Stack flex={1} spacing={1} justifyContent="space-between" sx={{ minHeight: 210 }}>
				<Box>
					<Typography variant="h6" noWrap>Criar Novo Filtro</Typography>
					<Typography variant="body2" color="text.secondary" noWrap>
						{props.subtitle || 'Personalize seus critérios e salve para reutilizar.'}
					</Typography>
				</Box>
				<CardActions sx={{ justifyContent: 'flex-end', p: 0 }}>
					<Button variant="contained" onClick={() => navigate('/stockscreener/0')}>Criar</Button>
				</CardActions>
			</Stack>
		</Card>
	)
}

export default CardCreateFilter
